module.exports = __webpack_public_path__ + "static/media/niss-image.d6f62d59.jpg";